<!-- 公告列表 -->
<template>
    <div class="bulletin">
        <lazy-load-list :getData="initData" :description="'暂无支付记录'" :query="query">
            <template v-slot="slotData">
                <div class="appeal-list">
                    <div class="flex align-center" v-for="(item, index) in slotData.dataList" :key="index">
                        <div class="appeal-list-item">
                            <div class="title">
                                {{ item.title }}
                            </div>
                            <div class="content">
                                {{ item.content }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </lazy-load-list>
    </div>
</template>

<script>
import { listBulletin } from "@/api/api";
import LazyLoadList from "@/components/base/lazyLoadList/lazy-load-list.vue";

export default {
    name: "Bulletin",
    data() {
        return {
            query: {
                pageNum: 0,
                pageSize: 10,
            },
        };
    },

    components: {
        LazyLoadList,
    },

    methods: {
        //给子组件使用
        initData() {
            return listBulletin(this.query);
        },
    },
};
</script>
<style lang="less" scoped>
.bulletin {
    padding: 16px 24px;
}

.appeal-list {
    padding: 16px 24px;
    .appeal-list-item {
        font-family: PingFang SC;
        width: 702px;
        border-radius: 16px;
        background-color: #fff;
        margin-bottom: 16px;
        padding: 32px 25px;
        .title {
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 20px;
            color: #333;
        }
        .content {
            color: #666;
            font-size: 28px;
        }
    }
}
</style>
